export const testLoginUrl = '/test/login?role=';